if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        // Add prev/next button handlers
        this.prevButton = this.querySelector('.slider-button--prev');
        this.nextButton = this.querySelector('.slider-button--next');

        if (this.prevButton && this.nextButton) {
          this.prevButton.addEventListener('click', () => this.goToPrev());
          this.nextButton.addEventListener('click', () => this.goToNext());
        }

        this.viewerHeight = this.elements.viewer.offsetHeight;
        this.elements.viewer.style.minHeight = this.viewerHeight + 'px';

        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        // remove active from all and add to the target
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        // find the thumbnail (may be null)
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        // set the aria/current and scroll thumbnail into view if present
        this.setActiveThumbnail(activeThumbnail);

        // safe announce: only call announceLiveRegion when we have an image and a position
        const position = activeThumbnail && activeThumbnail.dataset ? activeThumbnail.dataset.mediaPosition : null;
        this.announceLiveRegion(activeMedia, position);
      }

      setViewerHeight() {
        const activeMedia = this.elements.viewer.querySelector('.is-active');
        if (!activeMedia) return;
        const rect = activeMedia.getBoundingClientRect();
        this.elements.viewer.style.minHeight = rect.height + 'px';
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        // position may be null; activeItem may not contain an image (video/model); guard everything
        if (!activeItem) return;

        // If position is null, we won't announce index but we still can announce availability if needed.
        const image = activeItem.querySelector('.product__modal-opener--image img');

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          if (position) {
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          } else {
            // fallback announcement when index isn't available
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', '');
          }
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };

        // trigger the onload callback even if the image is already cached
        image.src = image.src;
      }


      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      goToPrev() {
        const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media]'));
        const activeIndex = mediaItems.findIndex(item => item.classList.contains('is-active'));

        if (activeIndex === -1) return;

        const prevIndex = (activeIndex - 1 + mediaItems.length) % mediaItems.length;
        const prevMediaId = mediaItems[prevIndex].dataset.mediaId;

        this.setActiveMedia(prevMediaId, false);
      }

      goToNext() {
        const mediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media]'));
        const activeIndex = mediaItems.findIndex(item => item.classList.contains('is-active'));

        if (activeIndex === -1) return;

        const nextIndex = (activeIndex + 1) % mediaItems.length;
        const nextMediaId = `${mediaItems[nextIndex].dataset.sectionId}-${mediaItems[nextIndex].dataset.media}`;

        this.setActiveMedia(nextMediaId, false);
      }

    }
  );
}
